module.exports = __webpack_public_path__ + "static/img/2areaA_10.1723380.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/2areaA_10.png
// module id = 809
// module chunks = 1